import { useState } from 'react';
import CrudPage from './shared/CrudPage';
import { getUsuarios, createUsuario, updateUsuario, deleteUsuario, getAdminId } from '../../api/adminClient';

export default function AdminUsuarios() {
  const [verBajas, setVerBajas] = useState(false);

  return (
    <CrudPage
      title="Usuarios"
      idKey="ID"
      columns={[
        { key: 'ID',             label: 'ID' },
        { key: 'apellido',       label: 'Apellido', sortable: true },
        { key: 'nombre',         label: 'Nombre', sortable: true },
        { key: 'email',          label: 'Email' },
        { key: 'nombre_usuario', label: 'Usuario', primary: true, sortable: true },
        { key: 'fecha_ultimo_login', label: 'Último login', sortable: true, render: (v) => v ? new Date(v).toLocaleString('es-AR') : '--' },
        { key: 'baja',           label: 'Fecha de Baja', render: (v, row) => v ? new Date(row.fecha_baja).toLocaleDateString('es-AR') : '--' },
      ]}
      fields={[
        { key: 'nombre_usuario', label: 'Usuario',    required: true },
        { key: 'nombre',         label: 'Nombre',     required: true },
        { key: 'apellido',       label: 'Apellido',   required: true },
        { key: 'email',          label: 'Email',      type: 'email', required: true },
        { key: 'password',       label: 'Contraseña (dejar vacío para no cambiar)', type: 'password' },
        { key: 'baja',           label: 'Baja',       type: 'checkbox' },
      ]}
      itemLabel="usuarios"
      fetchAll={getUsuarios}
      onCreate={createUsuario}
      onUpdate={updateUsuario}
      onDelete={deleteUsuario}
      deleteLabel="Dar de baja"
      deleteConfirmText="El administrador no se borra: queda marcado como 'Baja = Sí' y no podrá iniciar sesión, pero sigue apareciendo en este listado."
      canDelete={(row) => row.ID !== getAdminId()}
      rowClassName={(row) => row.baja ? 'bg-slate-100 text-slate-400' : ''}
      filterFn={verBajas ? null : (row) => !row.baja}
      toolbar={
        <label className="inline-flex items-center gap-2 text-sm text-slate-600 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={verBajas}
            onChange={(e) => setVerBajas(e.target.checked)}
            className="w-4 h-4 accent-violet-600"
          />
          Ver dados de baja
        </label>
      }
    />
  );
}
